import { RootState } from 'lib/core/data/reducer'
import { CartId } from '../../../../types'

export const getAddProduct = (sku: CartId) => (state: RootState) => {
  const slice = state.quote.addProduct[sku ?? '']
  return slice ?? {}
}
